import React from 'react';

import { Column as RCColumn } from 'rc-table';
import { RCColumnType, GridColumn } from './interfaces';

const withSortable = (Column: RCColumnType) => (props: GridColumn, index: number) =>
  <Column key={`column-ind${index}`} {...props} />;

export const DataGridColumn = withSortable(RCColumn);
